import React from 'react'
import AlphabetCell from './AlphabetCell'

const AlphabetGrid = ({ selectedPlain, selectedCipher }) => {

  return (
    <div style={{ textAlign: "left", width:"1500px"}}>
      <div style={{ display: "inline-block", margin: 0 }}>
        <AlphabetCell text={"A"} isCipher={selectedCipher === "A"} isPlain={selectedPlain === "A"} />
        <AlphabetCell text={"B"} isCipher={selectedCipher === "B"} isPlain={selectedPlain === "B"} />
        <AlphabetCell text={"C"} isCipher={selectedCipher === "C"} isPlain={selectedPlain === "C"} />
        <AlphabetCell text={"D"} isCipher={selectedCipher === "D"} isPlain={selectedPlain === "D"} />
        <AlphabetCell text={"E"} isCipher={selectedCipher === "E"} isPlain={selectedPlain === "E"} />
        <AlphabetCell text={"F"} isCipher={selectedCipher === "F"} isPlain={selectedPlain === "F"} />
        <AlphabetCell text={"G"} isCipher={selectedCipher === "G"} isPlain={selectedPlain === "G"} />
        <AlphabetCell text={"H"} isCipher={selectedCipher === "H"} isPlain={selectedPlain === "H"} />
        <AlphabetCell text={"I"} isCipher={selectedCipher === "I"} isPlain={selectedPlain === "I"} />
        <AlphabetCell text={"J"} isCipher={selectedCipher === "J"} isPlain={selectedPlain === "J"} />
        <AlphabetCell text={"K"} isCipher={selectedCipher === "K"} isPlain={selectedPlain === "K"} />
        <AlphabetCell text={"L"} isCipher={selectedCipher === "L"} isPlain={selectedPlain === "L"} />
        <AlphabetCell text={"M"} isCipher={selectedCipher === "M"} isPlain={selectedPlain === "M"} />
        <AlphabetCell text={"N"} isCipher={selectedCipher === "N"} isPlain={selectedPlain === "N"} />
        <AlphabetCell text={"O"} isCipher={selectedCipher === "O"} isPlain={selectedPlain === "O"} />
        <AlphabetCell text={"P"} isCipher={selectedCipher === "P"} isPlain={selectedPlain === "P"} />
        <AlphabetCell text={"Q"} isCipher={selectedCipher === "Q"} isPlain={selectedPlain === "Q"} />
        <AlphabetCell text={"R"} isCipher={selectedCipher === "R"} isPlain={selectedPlain === "R"} />
        <AlphabetCell text={"S"} isCipher={selectedCipher === "S"} isPlain={selectedPlain === "S"} />
        <AlphabetCell text={"T"} isCipher={selectedCipher === "T"} isPlain={selectedPlain === "T"} />
        <AlphabetCell text={"U"} isCipher={selectedCipher === "U"} isPlain={selectedPlain === "U"} />
        <AlphabetCell text={"V"} isCipher={selectedCipher === "V"} isPlain={selectedPlain === "V"} />
        <AlphabetCell text={"W"} isCipher={selectedCipher === "W"} isPlain={selectedPlain === "W"} />
        <AlphabetCell text={"X"} isCipher={selectedCipher === "X"} isPlain={selectedPlain === "X"} />
        <AlphabetCell text={"Y"} isCipher={selectedCipher === "Y"} isPlain={selectedPlain === "Y"} />
        <AlphabetCell text={"Z"} isCipher={selectedCipher === "Z"} isPlain={selectedPlain === "Z"} isLast={true} />
      </div>

      <div style={{ display: "inline-block", margin: 0 }}>
        <AlphabetCell text={"00"} />
        <AlphabetCell text={"01"} />
        <AlphabetCell text={"02"} />
        <AlphabetCell text={"03"} />
        <AlphabetCell text={"04"} />
        <AlphabetCell text={"05"} />
        <AlphabetCell text={"06"} />
        <AlphabetCell text={"07"} />
        <AlphabetCell text={"08"} />
        <AlphabetCell text={"09"} />
        <AlphabetCell text={"10"} />
        <AlphabetCell text={"11"} />
        <AlphabetCell text={"12"} />
        <AlphabetCell text={"13"} />
        <AlphabetCell text={"14"} />
        <AlphabetCell text={"15"} />
        <AlphabetCell text={"16"} />
        <AlphabetCell text={"17"} />
        <AlphabetCell text={"18"} />
        <AlphabetCell text={"19"} />
        <AlphabetCell text={"20"} />
        <AlphabetCell text={"21"} />
        <AlphabetCell text={"22"} />
        <AlphabetCell text={"23"} />
        <AlphabetCell text={"24"} />
        <AlphabetCell text={"25"} isLast={true} />

      </div>
    </div>
  )
}

export default AlphabetGrid